import React, { useState, useEffect } from 'react';
import './UtilityButtons.css';
// Import des composants Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Import des icônes spécifiques que nous allons utiliser
import { faPhone, faArrowUp } from '@fortawesome/free-solid-svg-icons';

const UtilityButtons = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);
  const phoneNumber = "05 61 88 75 78"; // Le numéro de téléphone de Sabine et David CASTEX

  // Effect to show/hide the scroll-to-top button
  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling down 300px
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scrolling animation
    });
  };

  return (
    <div className="utility-buttons-container">
      {/* Phone Number Button */}
      <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className="phone-button">
        <FontAwesomeIcon icon={faPhone} className="phone-icon" />
        <span className="phone-text">{phoneNumber}</span>
      </a>

      {/* Scroll to Top Button */}
      {showScrollButton && (
        <button onClick={scrollToTop} className="scroll-to-top-button">
          <FontAwesomeIcon icon={faArrowUp} className="arrow-icon" />
        </button>
      )}
    </div>
  );
};

export default UtilityButtons;